import { useNoteName } from '../../../Project/ProjectStore'
import './accidentals.css'
export interface AccidentalSplitProps{
    tonic:number
    baseFontSize?:number
    primaryLabel?:string
}
export function AccidentalSplit(props:AccidentalSplitProps){
    const noteName:string = useNoteName(props.tonic)
    const chars:string[] = noteName.split('')
    if(chars.length === 1){
        return <span className={'accidental-split'}>{noteName}</span>
    }
    return <span className={'accidental-split'}>
            <span>{chars[0]}</span>
            <sup className={'accidental'}>{chars[1]}</sup>
            </span>
}




export function SVGAccidentalSplit(props:AccidentalSplitProps){
    let noteName:string = useNoteName(props.tonic)
    noteName = (props.primaryLabel) ? props.primaryLabel : noteName
    const chars:string[] = noteName.split('')
    if(chars.length === 1){
        return <g className={'accidental-split'}>
                    <text dy={'.25em'} fontSize={props.baseFontSize} className={'accidental-split-base'}>
                        <tspan>{noteName}</tspan>
                    </text>
                </g>
    }
    const baseFontSize:number = (props.baseFontSize) ? props.baseFontSize : 16;
    const accidentalRatio:number = .6
    const accidentalFontSize:number = baseFontSize * accidentalRatio
    return <g className={'accidental-split accidental-included'}>
            <text>
                <tspan dy={'.25em'}  fontSize={baseFontSize} 
                        className={'accidental-split-base'}>{chars[0]}</tspan>
                <tspan fontSize={accidentalFontSize} 
                        className={'accidental'}>{chars[1]}</tspan>
            </text>
            </g>
}